jQuery(document).ready(function ($) {
  // companion script for the mega menu
  $(' .menu-item-type-taxonomy').mouseenter(
    function () {
      $('.parent-category-link', this).first().addClass('hovered');
    }
  )

  $('.header-main .parent-category-link').mouseenter(
    function () {
      $("body").off('mouseenter', '.menu-item-type-taxonomy');
      $('.parent-category-link').removeClass('hovered');
    });

  $('.header-main .nav-sublist-container').mouseleave(
    function() {
      $('.nav-sublist-dropdown').css({ "visibility": "hidden", "opacity": "0" });
      setTimeout(
        function() {
          $('.nav-sublist-dropdown').removeAttr('style');
        }, 100);
    }
  )

  $('.header-main .parent-category-link').click(
    function () {
      window.location.href = $('a', this).attr('href');
    }
  );
});